import React from 'react';

import { Space, Typography } from 'antd';

import FromIcon from './icons/FromIcon';
import ToIcon from './icons/ToIcon';
import datatransforms from '@/helpers/datatransforms';

const formatCompanyLine = (address?: { company?: string }) => {
  const contactName = datatransforms.concatNames(address || {});
  const company = address?.company?.trim();
  const companySuffix =
    company && company.length > 30 ? company.slice(-15) : '';
  const fullLabel = company
    ? contactName
      ? `${company} (${contactName})`
      : company
    : contactName;

  if (!company && !contactName) return null;

  if (!company) {
    return (
      <span title={fullLabel}>
        <small>
          <em>{contactName}</em>
        </small>
      </span>
    );
  }

  return (
    <>
      <Typography.Text
        ellipsis={
          companySuffix
            ? { tooltip: fullLabel, suffix: companySuffix }
            : { tooltip: fullLabel }
        }
      >
        {company}
      </Typography.Text>
      {contactName && (
        <div>
          <small>
            <em>{contactName}</em>
          </small>
        </div>
      )}
    </>
  );
};

const RecipientSender = (props: {
  recipientAddress?: { company?: string } | null;
  senderAddress?: { company?: string } | null;
}) => {
  const senderLine = formatCompanyLine(props.senderAddress ?? undefined);
  const recipientLine = formatCompanyLine(props.recipientAddress ?? undefined);

  if (!senderLine && !recipientLine) return null;

  return (
    <Space direction="vertical" size="small">
      {senderLine && (
        <Space align="start" size="small">
          <FromIcon />
          <div>{senderLine}</div>
        </Space>
      )}
      {recipientLine && (
        <Space align="start" size="small">
          <ToIcon />
          <div>{recipientLine}</div>
        </Space>
      )}
    </Space>
  );
};

export default RecipientSender;
